import React from 'react';

type TProps = {
  input: any;
  register: any;
}

function SelectBox({input, register}: TProps) {
  return (
    <select className='select-box' {...register(input.name, { required: true })}>
      {input.values.map((item: any, key: number) => {
        return (
          <option key={key} value={item.value}>{item.label}</option>
        )
      })}
    </select>
  );
}

export default SelectBox;